import React from 'react';
import { observer } from 'mobx-react-lite';
import { buildGroupContextMoreInfoBlobProps } from 'components/common/group/GroupContextMoreInfoBlob';
import { GeneralRouteV2Id } from 'routes/routesConfigV2';
import PageInFlowNoSidebarLayout from 'components/common/general/layouts/PageInFlowNoSidebarLayout';
import InitiateQuoteFlowDelegate from 'store/flows/initiate-quote/initiateQuoteFlowDelegate';
import BulletTabsDelegate from 'store/general/bulletTabsDelegate';
import { INITIATE_PROPOSAL_BULLET_TABS_TEST_ID } from '../constants';
import { BulletTabsStyled } from './styles';

interface Props {
  initiateQuoteFlowDelegate: InitiateQuoteFlowDelegate;
  bulletTabsDelegate: BulletTabsDelegate;
  tabs: React.ReactNode[];
}

const InitiateProposalPageLayout: React.FC<Props> = observer(
  ({ initiateQuoteFlowDelegate, bulletTabsDelegate, tabs }) => {
    const {
      isInitialDataLoading,
      isFlowDataLoading,
      domainData: { groupId },
      groupInfoDelegate,
    } = initiateQuoteFlowDelegate;

    const {
      currentStepIndex,
      isCurrentStepValid,
      canCompleteStep,
      isActionLoading,
      navigateToPreviousStep,
      navigateToNextStep,
      completeFlow,
    } = bulletTabsDelegate;

    const moreInfoBlob = groupInfoDelegate.moreInfoBlobInput
      ? buildGroupContextMoreInfoBlobProps(groupInfoDelegate.moreInfoBlobInput)
      : undefined;

    return (
      <PageInFlowNoSidebarLayout
        contentWidth="standard"
        domainParams={{ groupId }}
        pageId={GeneralRouteV2Id.INITIATE_PROPOSAL}
        pageHeader={{ subtitleMaxWidth: '46rem' }}
        isInitialLoading={isInitialDataLoading}
        isInfoSectionLoading={isFlowDataLoading}
        isActionLoading={isActionLoading}
        moreInfoBlob={moreInfoBlob}
        pageFooter={null}
      >
        <BulletTabsStyled
          title="Step"
          tabs={tabs}
          onBack={navigateToPreviousStep}
          onNext={navigateToNextStep}
          onComplete={completeFlow}
          disableNextBtn={!isCurrentStepValid}
          disableCompleteBtn={!canCompleteStep}
          completeBtnText="Save Proposal"
          backBtnText={currentStepIndex === 0 ? 'Back to Group' : 'Back'}
          isLoading={isActionLoading}
          data-test-id={INITIATE_PROPOSAL_BULLET_TABS_TEST_ID}
        />
      </PageInFlowNoSidebarLayout>
    );
  },
);

export default InitiateProposalPageLayout;
